module.exports = __webpack_public_path__ + "img/medico.b3175581.png";